(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mx-storefront"] && !Shopify.designMode) return;
  try {
    
(() => {
const root=document.querySelector('.mx-catalog'); if(!root)return;
const cards=[...root.querySelectorAll('.mx-card')]; let saved=new Set(); let onlySaved=false;
try{saved=new Set(JSON.parse(localStorage.getItem('mxm-saved-concepts')||'[]'));}catch{}
const query=root.querySelector('#mx-concept-search');
function paint(){cards.forEach(c=>{c.querySelector('.mx-save').setAttribute('aria-pressed',String(saved.has(c.dataset.key)));});root.querySelector('[data-saved-count]').textContent=saved.size;}
function filter(){const term=query.value.trim().toLowerCase();root.querySelectorAll('.mx-product-section').forEach(section=>{const selected=section.querySelector('[data-filter][aria-pressed=true]').dataset.filter;let shown=0;section.querySelectorAll('.mx-card').forEach(c=>{const visible=(selected==='all'||c.dataset.kind===selected)&&(!onlySaved||saved.has(c.dataset.key))&&c.querySelector('h3').textContent.toLowerCase().includes(term);c.hidden=!visible;if(visible)shown++;});section.querySelector('.mx-no-match').hidden=shown>0;});}
root.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{b.closest('.mx-filters').querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));filter();}));
root.querySelectorAll('.mx-save').forEach(b=>b.addEventListener('click',()=>{const key=b.closest('.mx-card').dataset.key;saved.has(key)?saved.delete(key):saved.add(key);try{localStorage.setItem('mxm-saved-concepts',JSON.stringify([...saved]));}catch{}paint();filter();}));
root.querySelector('.mx-saved-toggle').addEventListener('click',e=>{onlySaved=!onlySaved;e.currentTarget.setAttribute('aria-pressed',String(onlySaved));filter();});
query.addEventListener('input',filter);
const dialog=root.querySelector('dialog');let opener;
root.querySelectorAll('.mx-open').forEach(b=>b.addEventListener('click',()=>{opener=b;dialog.querySelector('[data-modal-title]').textContent=b.querySelector('h3').textContent;dialog.querySelector('[data-modal-price]').textContent=b.dataset.price;dialog.querySelector('[data-modal-description]').textContent=b.dataset.desc;dialog.querySelector('.mx-modal-art').replaceChildren(b.querySelector('.mx-art').cloneNode(true));dialog.showModal();}));
dialog.querySelector('.mx-dialog-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});dialog.addEventListener('close',()=>opener?.focus());paint();
})();

  } catch(e) { console.error(e); }
})();
})();
